import { createContext, useContext, useEffect, useState } from "react";
import { getSetting, setSetting } from "../utils/Db";
import { AccordionCharts, defaultSettings } from "../utils/dashboardAccessList";

const DashboarderSettingContext = createContext();

export const DashboardSettingProvider = ({ children }) => {
  const [dashControlleChart, setDashControlleChart] = useState([]);
  const [dashboardAccrdion, setDashboardAccrdion] = useState([]);

  useEffect(() => {
    getSetting("dashboardSettings").then((stored) => {
      if (stored !== undefined) {
        setDashControlleChart([...stored]);
      } else {
        setDashControlleChart([...defaultSettings]);
        setSetting("dashboardSettings", defaultSettings);
      }
    });
    getSetting("dashboardAccrdion").then((stored) => {
      if (stored !== undefined) {
        setDashboardAccrdion([...stored]);
      } else {
        setDashboardAccrdion([...AccordionCharts]);
        setSetting("dashboardAccrdion", AccordionCharts);
      }
    });
  }, []);

  /* --------------------------------- update --------------------------------- */
  const update = (partial) => {
    setDashControlleChart((prev) => {
      const updated = prev.map((item) =>
        item.chart === partial.chart ? { ...item, ...partial } : item
      );
      setSetting("dashboardSettings", updated);
      return [...updated];
    });
  };

  const updateAccrdion = (partial) => {
    setDashboardAccrdion((prev) => {
      const updated = prev.map((item) =>
        item.chart === partial.chart ? { ...item, ...partial } : item
      );
      setSetting("dashboardAccrdion", updated);
      return [...updated];
    });
  };
  /* ---------------------------------- Save ---------------------------------- */
  const save = (newValues) => {
    setDashControlleChart([...newValues]);
    setSetting("dashboardSettings", newValues);
  };
  const saveAccrdion = (newValues) => {
    setDashboardAccrdion([...newValues]);
    setSetting("dashboardAccrdion", newValues);
  };
  return (
    <DashboarderSettingContext.Provider
      value={{ dashControlleChart, update, save, dashboardAccrdion,updateAccrdion ,saveAccrdion }}
    >
      {children}
    </DashboarderSettingContext.Provider>
  );
};
/**
 *
 * @returns  {dashControlleChart , update , save}
 */
export const useDashboardSettings = () => {
  return useContext(DashboarderSettingContext);
};
